export default __webpack_public_path__ + "static/media/timelineUserRemoved.b386ff03.svg";